<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable no-undef -->
<script setup>
import {
  onBeforeMount,
  reactive,
  ref,
  // useAttrs,
  watch,
} from "@vue/runtime-core";
import axios from "axios";
import { useStore } from "vuex";
import Placeholder from "@/components/Placeholder.vue";
import { alertError } from "@/assets/js/utils";
import { useRoute } from "vue-router";
// import imageIcon from "@/assets/static/image-icon.jpg";
import { defineProps } from "vue";

const props = defineProps(["type"]);

// let attrs = useAttrs();
let store = useStore();
let route = useRoute();
let venue = reactive({
  data: null,
  meta: null,
  loading: false,
  loadingMore: false,
});
let activityType = reactive({
  data: [],
  loading: false,
});
let companyType = reactive({
  data: [],
  loading: false,
});
let params = reactive({
  search: null,
  destination_name: route.query.name,
  type: props.type,
  activity_type: [],
  company_type: [],
  sort: "desc",
  field: "created_at",
  per_page: 10,
  order: "a-z",
});
let compares = ref([]);
let uuids = ref([]);

function fetchData(url) {
  venue.loading = true;
  axios
    .get(url, { params })
    .then((response) => {
      venue.data = response.data.data.data;
      venue.meta = response.data.data;
      venue.loading = false;
    })
    .catch((error) => {
      console.log(error);
      venue.loading = false;
    });
}

function next(url) {
  venue.loadingMore = true;
  axios
    .get(url)
    .then((response) => {
      venue.data.push(...response.data.data.data);
      venue.meta = response.data.data;
      venue.loadingMore = false;
    })
    .catch((error) => {
      console.log(error);
      venue.loadingMore = false;
    });
}

function addCompareData(data) {
  let isCompared = false;

  compares.value.forEach((item, index) => {
    if (item.uuid === data.uuid) {
      isCompared = true;
      compares.value.splice(index, 1);
      uuids.value.splice(index, 1);
      data.compared = false;
    }
  });

  if (compares.value.length >= 5) {
    alertError("Maksimal 5 data yang dapat dibandingkan");
    return;
  }

  if (!isCompared) {
    data.compared = true;
    compares.value.push(data);
    uuids.value.push(data.uuid);
  }
}

function like(data) {
  axios
    .post(`${store.state.urlNewInventoryFront}like`, {
      fk_id: data.uuid,
    })
    .then(() => {
      data.like = true;
    })
    .catch((err) => {
      console.log(err);
    });
}

onBeforeMount(() => {
  document.title = "List Venue | MICE";
  fetchData(`${store.state.urlNewInventoryFront}inventory`);

  axios
    .get(`${store.state.urlNewEventFront}activity-type`)
    .then((res) => {
      activityType.data = res.data.data;
    })
    .catch((err) => {
      console.log(err);
    });

  axios
    .get(`${store.state.urlNewEventFront}company-type`)
    .then((res) => {
      companyType.data = res.data.data;
    })
    .catch((err) => {
      console.log(err);
    });
});

watch(
  params,
  () => {
    fetchData(`${store.state.urlNewInventoryFront}inventory`);
    compares.value = [];
  },
  { deep: true }
);

watch(
  props,
  () => {
    params.type = props.type;
    fetchData(`${store.state.urlNewInventoryFront}inventory`);
    compares.value = [];
  },
  { deep: true }
);

watch(
  compares,
  () => {
    if (compares.value.length > 0) {
      const bsOffcanvas = new bootstrap.Offcanvas("#compareOffcanvas");
      bsOffcanvas.show();
    }
  },
  { deep: true }
);
</script>

<template>
  <div>
    <div class="offcanvas offcanvas-bottom" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1"
      id="offcanvasFilter" aria-labelledby="offcanvasFilterLabel">
      <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasFilterLabel">Filter</h5>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body">
        <div class="row">
          <div class="col-lg-12">
            <div class="d-flex justify-content-between" v-if="activityType.data.length > 0">
              <h6>Tipe Aktivitas</h6>
              <span class="text-black-50 small pointer" @click="params.activity_type = []">Clear</span>
            </div>
            <div class="row mb-3" v-if="activityType.data.length > 0">
              <div class="col-lg-12" v-for="(data, i) in activityType.data" :key="i">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" :value="data.name" :id="`activity-type-${i}`"
                    v-model="params.activity_type" />
                  <label class="form-check-label" :for="`activity-type-${i}`">
                    {{ data.name }}
                  </label>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between" v-if="companyType.data.length > 0">
              <h6>Tipe Perusahaan</h6>
              <span class="text-black-50 small pointer" @click="params.company_type = []">Clear</span>
            </div>
            <div class="row mb-3" v-if="companyType.data.length > 0">
              <div class="col-lg-12" v-for="(data, i) in companyType.data" :key="i">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" :value="data.name" :id="`company-type-${i}`"
                    v-model="params.company_type" />
                  <label class="form-check-label" :for="`company-type-${i}`">
                    {{ data.name }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="container-xl my-5 px-lg-5">
      <div class="row px-lg-5">
        <!-- <div class="col-lg-3 d-none d-lg-block">
          <div class="d-flex justify-content-between">
            <h6>FILTERS</h6>
            <span
              class="text-black-50 small pointer"
              @click="
                () => {
                  params.activity_type = [];
                  params.company_type = [];
                }
              "
              >Clear all filters</span
            >
          </div>
          <hr
            style="margin-top: -5px"
            class="border-top border-dark border-3"
          />
          <div
            class="d-flex justify-content-between"
            v-if="activityType.data.length > 0"
          >
            <h6>Tipe Aktivitas</h6>
            <span
              class="text-black-50 small pointer"
              @click="params.activity_type = []"
              >Clear</span
            >
          </div>
          <div class="row mb-3" v-if="activityType.data.length > 0">
            <div
              class="col-lg-12"
              v-for="(data, i) in activityType.data"
              :key="i"
            >
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :value="data.name"
                  :id="`activity-type-${i}`"
                  v-model="params.activity_type"
                />
                <label class="form-check-label" :for="`activity-type-${i}`">
                  {{ data.name }}
                </label>
              </div>
            </div>
          </div>
          <div
            class="d-flex justify-content-between"
            v-if="companyType.data.length > 0"
          >
            <h6>Tipe Perusahaan</h6>
            <span
              class="text-black-50 small pointer"
              @click="params.company_type = []"
              >Clear</span
            >
          </div>
          <div class="row mb-3" v-if="companyType.data.length > 0">
            <div
              class="col-lg-12"
              v-for="(data, i) in companyType.data"
              :key="i"
            >
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :value="data.name"
                  :id="`company-type-${i}`"
                  v-model="params.company_type"
                />
                <label class="form-check-label" :for="`company-type-${i}`">
                  {{ data.name }}
                </label>
              </div>
            </div>
          </div>
        </div> -->
        <div class="col-lg-12">
          <div class="d-flex mb-3 pe-1 justify-content-between">
            <div class="col-8 me-1">
              <div class="mb-3">
                <input type="text" class="form-control" :placeholder="$t('Searchkeywords')" v-model="params.search" />
              </div>
            </div>
            <div class="col-4">
              <select class="form-select" aria-label="Default select example" v-model="params.order">
                <option value="a-z">A - Z</option>
                <option value="z-a">Z - A</option>
                <option value="1-5">Lowest Rating</option>
                <option value="5-1">Highest Rating</option>
              </select>
            </div>
          </div>
          <div class="row mb-5" v-if="venue.loading">
            <div class="col-lg-12 mb-2">
              <Placeholder />
            </div>
            <div class="col-lg-12 mb-2">
              <Placeholder />
            </div>
          </div>
          <div class="row mb-5" v-if="!venue.loading && venue.data.length == 0">
            <div class="col-lg-12 mb-2">Tidak ada data</div>
          </div>
          <div class="row mb-5" v-if="!venue.loading && venue.data.length > 0">
            <div class="col-lg-12 mb-2" v-for="(data, i) in venue.data" :key="i">
              <div class="card mb-3 rounded-custom border-0 shadow-sm">
                <div class="row">
                  <div class="col-md-4">
                    <img :src="data.photo_primary?.url" class="img-fluid rounded-custom" alt="..."
                      style="width: 100%" />
                  </div>
                  <div class="col-md-8">
                    <router-link :to="{
                      name: 'ListInventoryDetail',
                      params: { id: `${data.uuid}` },
                    }" class="text-dark">
                      <div class="card-body">
                        <div class="d-flex justify-content-between mb-3">
                          <span class="h5 me-3 card-title fw-bold">
                            {{ data.title }}
                          </span>
                          <i class="fa-regular fa-heart fa-2x" @click.prevent="like(data)" v-if="!data.like"></i>
                          <i class="fas fa-heart fa-2x text-danger" @click.prevent="like(data)" v-else></i>
                        </div>
                        <div class="card-text three-line mb-3" v-html="data.deskripsi"></div>
                        <p class="small">
                          {{
                            `${data.jalan}, ${data.kotakabupaten}, ${data.provinsi}`
                          }}
                        </p>
                        <div class="small" v-if="data.jumlah_meeting_room">
                          {{ data.jumlah_meeting_room }} Meeting Rooms
                        </div>
                        <div class="small" v-if="data.min_capacity && data.max_capacity">
                          {{ data.min_capacity }} to
                          {{ data.max_capacity }} persons
                        </div>
                        <p>
                          <i class="fas fa-star small text-warning" v-for="s in data.stars" :key="s"></i>
                        </p>
                        <!-- <p class="card-text">
                          <small class="text-muted d-block mb-2">
                            <i class="fas fa-building me-2"></i>Distance from
                            City: 200 M
                          </small>
                          <small class="text-muted d-block mb-2">
                            <i class="fas fa-users me-2"></i>Capacity max:
                            {{ data.capacity }}
                          </small>
                        </p> -->
                      </div>
                    </router-link>
                    <button :class="`btn btn-sm ${data.compared ? 'btn-warning-mice' : 'bg-secondary-mice'
                      } rounded-custom me-2 ms-3 mb-3 text-white`" @click="addCompareData(data)">
                      <i class="fas fa-check me-2"></i>{{ $t('Compare') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center" v-if="venue.meta?.links[venue.meta?.links.length - 1].url != null">
            <button class="btn btn-primary rounded-custom border-0 py-2 px-3 bg-secondary-mice me-2"
              @click="next(venue.meta?.links[venue.meta?.links.length - 1].url)" :disabled="venue.loadingMore">
              {{ $t('LoadMore') }}
            </button>
          </div>
        </div>
      </div>
    </section>
    <div class="offcanvas offcanvas-bottom" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1"
      id="compareOffcanvas" aria-labelledby="compareOffcanvasLabel">
      <div class="offcanvas-body">
        <div class="row">
          <div class="col-lg-10">
            <div class="row" v-if="compares.length == 0">
              <div class="col-lg-12 text-center mb-5">Tidak ada data</div>
            </div>
            <div class="row" v-if="compares.length > 0">
              <div class="col-3 col-lg-2 mb-3" v-for="(data, i) in compares" :key="i">
                <img :src="data.photo_primary?.url" alt="" style="width: 100%" class="img-fluid rounded-custom pointer"
                  @click="compares.splice(i, 1)" />
              </div>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="row">
              <div class="col-lg-12 d-grid">
                <router-link :to="{
                  name: 'ListInventoryCompare',
                  query: { uuids: uuids },
                }" class="btn btn-sm btn-warning-mice rounded-custom me-2 ms-3 mb-3 text-white">
                  <i class="fas fa-check me-2"></i>{{ $t('Compare') }}
                </router-link>
              </div>
              <div class="col-lg-12 d-grid">
                <button type="button" class="btn btn-sm btn-outline-secondary rounded-custom me-2 ms-3 mb-3"
                  data-bs-dismiss="offcanvas" aria-label="Close">
                  <i class="fas fa-times me-2"></i>{{ $t('Close') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
